// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --PhoneInput-color--focus: #03b2cb;
  --PhoneInputInternationalIconPhone-opacity: 0.8;
  --PhoneInputInternationalIconGlobe-opacity: 0.65;
  --PhoneInputCountrySelect-marginRight: 0.35em;
  --PhoneInputCountrySelectArrow-width: 0.3em;
  --PhoneInputCountrySelectArrow-marginLeft: var(--PhoneInputCountrySelect-marginRight);
  --PhoneInputCountrySelectArrow-borderWidth: 1px;
  --PhoneInputCountrySelectArrow-opacity: 0.45;
  --PhoneInputCountrySelectArrow-color: inherit;
  --PhoneInputCountrySelectArrow-color--focus: var(--PhoneInput-color--focus);
  --PhoneInputCountrySelectArrow-transform: rotate(45deg);
  --PhoneInputCountryFlag-aspectRatio: 1.5;
  --PhoneInputCountryFlag-height: 1em;
  --PhoneInputCountryFlag-borderWidth: 1px;
  --PhoneInputCountryFlag-borderColor: rgba(0, 0, 0, 0.5);
  --PhoneInputCountryFlag-borderColor--focus: var(--PhoneInput-color--focus);
  --PhoneInputCountryFlag-backgroundColor--loading: rgba(0, 0, 0, 0.1);
}

.PhoneInput {
    display: flex;
    align-items: center;
    height: 30px;
    border: 1px solid rgba(0, 0, 0, 0.4);
    padding: 0px 6px;
    border-radius: 4px;
  }

.PhoneInputInput {
    flex: 1;
    min-width: 0;
    height: 100%;
    margin-left: 10px;
    font-family: 'Helvetica Neue', Helvetica, Arial;
    font-size: 18px;
    border: none;
    outline: none;
  }

.PhoneInputCountryIcon {
    width: calc(var(--PhoneInputCountryFlag-height) * var(--PhoneInputCountryFlag-aspectRatio));
    height: var(--PhoneInputCountryFlag-height);
    max-width: 30px;
    border-radius: 2px;
    overflow: hidden;
  }

.PhoneInputCountryIcon--square {
    width: var(--PhoneInputCountryFlag-height);
  }

.PhoneInputCountryIcon--border {
    background-color: var(--PhoneInputCountryFlag-backgroundColor--loading);
    box-shadow: 0 0 0 var(--PhoneInputCountryFlag-borderWidth) var(--PhoneInputCountryFlag-borderColor),
      inset 0 0 0 var(--PhoneInputCountryFlag-borderWidth) var(--PhoneInputCountryFlag-borderColor);
  }

.PhoneInputCountryIconImg {
    display: block;
    width: 100%;
    height: 100%;
  }

.PhoneInputInternationalIconPhone {
    opacity: var(--PhoneInputInternationalIconPhone-opacity);
  }

.PhoneInputInternationalIconGlobe {
    opacity: var(--PhoneInputInternationalIconGlobe-opacity);
  }

.PhoneInputCountry {
    position: relative;
    align-self: stretch;
    display: flex;
    align-items: center;
    margin-right: var(--PhoneInputCountrySelect-marginRight);
  }

.PhoneInputCountrySelect {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 1;
    border: 0;
    opacity: 0;
    cursor: pointer;
  }

.PhoneInputCountrySelect[disabled] {
    cursor: default;
  }

.PhoneInputCountrySelectArrow {
    display: block;
    content: '';
    width: var(--PhoneInputCountrySelectArrow-width);
    height: var(--PhoneInputCountrySelectArrow-width);
    margin-left: var(--PhoneInputCountrySelectArrow-marginLeft);
    border-style: solid;
    border-color: var(--PhoneInputCountrySelectArrow-color);
    border-top-width: 0;
    border-bottom-width: var(--PhoneInputCountrySelectArrow-borderWidth);
    border-left-width: 0;
    border-right-width: var(--PhoneInputCountrySelectArrow-borderWidth);
    transform: var(--PhoneInputCountrySelectArrow-transform);
    opacity: var(--PhoneInputCountrySelectArrow-opacity);
  }

.PhoneInputCountrySelect:focus + .PhoneInputCountryIcon + .PhoneInputCountrySelectArrow {
    opacity: 1;
    color: var(--PhoneInputCountrySelectArrow-color--focus);
  }

.PhoneInputCountrySelect:focus + .PhoneInputCountryIcon--border {
    box-shadow: 0 0 0 var(--PhoneInputCountryFlag-borderWidth) var(--PhoneInputCountryFlag-borderColor--focus),
      inset 0 0 0 var(--PhoneInputCountryFlag-borderWidth) var(--PhoneInputCountryFlag-borderColor--focus);
  }

.PhoneInputCountrySelect:focus + .PhoneInputCountryIcon .PhoneInputInternationalIconGlobe {
    opacity: 1;
    color: var(--PhoneInputCountrySelectArrow-color--focus);
  }

.app-components-Form-PhoneInput-___PhoneInput-module__container {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.app-components-Form-PhoneInput-___PhoneInput-module__fieldError {
  position: absolute;
  right: 0px;
}

.app-components-Form-PhoneInput-___PhoneInput-module__error {
  border-color: var(--colors-red);
  box-shadow: 0 0 3px var(--colors-red);
}
`, "",{"version":3,"sources":["webpack://./app/components/Form/PhoneInput/PhoneInput.module.scss"],"names":[],"mappings":"AAAA;EACE,kCAAkC;EAClC,+CAA+C;EAC/C,gDAAgD;EAChD,6CAA6C;EAC7C,2CAA2C;EAC3C,qFAAqF;EACrF,+CAA+C;EAC/C,4CAA4C;EAC5C,6CAA6C;EAC7C,2EAA2E;EAC3E,uDAAuD;EACvD,wCAAwC;EACxC,mCAAmC;EACnC,wCAAwC;EACxC,uDAAuD;EACvD,0EAA0E;EAC1E,oEAAoE;AACtE;;AAGE;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,oCAAoC;IACpC,gBAAgB;IAChB,kBAAkB;EACpB;;AAEA;IACE,OAAO;IACP,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,+CAA+C;IAC/C,eAAe;IACf,YAAY;IACZ,aAAa;EACf;;AAEA;IACE,2FAA2F;IAC3F,2CAA2C;IAC3C,eAAe;IACf,kBAAkB;IAClB,gBAAgB;EAClB;;AAEA;IACE,0CAA0C;EAC5C;;AAEA;IACE,uEAAuE;IACvE;mGAC+F;EACjG;;AAEA;IACE,cAAc;IACd,WAAW;IACX,YAAY;EACd;;AAEA;IACE,wDAAwD;EAC1D;;AAEA;IACE,wDAAwD;EAC1D;;AAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,wDAAwD;EAC1D;;AAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,WAAW;IACX,UAAU;IACV,SAAS;IACT,UAAU;IACV,eAAe;EACjB;;AAEA;IACE,eAAe;EACjB;;AAEA;IACE,cAAc;IACd,WAAW;IACX,gDAAgD;IAChD,iDAAiD;IACjD,2DAA2D;IAC3D,mBAAmB;IACnB,uDAAuD;IACvD,mBAAmB;IACnB,oEAAoE;IACpE,oBAAoB;IACpB,mEAAmE;IACnE,wDAAwD;IACxD,oDAAoD;EACtD;;AAEA;IACE,UAAU;IACV,uDAAuD;EACzD;;AAEA;IACE;0GACsG;EACxG;;AAEA;IACE,UAAU;IACV,uDAAuD;EACzD;;AAGF;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;AACvC","sourcesContent":[":root {\n  --PhoneInput-color--focus: #03b2cb;\n  --PhoneInputInternationalIconPhone-opacity: 0.8;\n  --PhoneInputInternationalIconGlobe-opacity: 0.65;\n  --PhoneInputCountrySelect-marginRight: 0.35em;\n  --PhoneInputCountrySelectArrow-width: 0.3em;\n  --PhoneInputCountrySelectArrow-marginLeft: var(--PhoneInputCountrySelect-marginRight);\n  --PhoneInputCountrySelectArrow-borderWidth: 1px;\n  --PhoneInputCountrySelectArrow-opacity: 0.45;\n  --PhoneInputCountrySelectArrow-color: inherit;\n  --PhoneInputCountrySelectArrow-color--focus: var(--PhoneInput-color--focus);\n  --PhoneInputCountrySelectArrow-transform: rotate(45deg);\n  --PhoneInputCountryFlag-aspectRatio: 1.5;\n  --PhoneInputCountryFlag-height: 1em;\n  --PhoneInputCountryFlag-borderWidth: 1px;\n  --PhoneInputCountryFlag-borderColor: rgba(0, 0, 0, 0.5);\n  --PhoneInputCountryFlag-borderColor--focus: var(--PhoneInput-color--focus);\n  --PhoneInputCountryFlag-backgroundColor--loading: rgba(0, 0, 0, 0.1);\n}\n\n:global {\n  .PhoneInput {\n    display: flex;\n    align-items: center;\n    height: 30px;\n    border: 1px solid rgba(0, 0, 0, 0.4);\n    padding: 0px 6px;\n    border-radius: 4px;\n  }\n\n  .PhoneInputInput {\n    flex: 1;\n    min-width: 0;\n    height: 100%;\n    margin-left: 10px;\n    font-family: 'Helvetica Neue', Helvetica, Arial;\n    font-size: 18px;\n    border: none;\n    outline: none;\n  }\n\n  .PhoneInputCountryIcon {\n    width: calc(var(--PhoneInputCountryFlag-height) * var(--PhoneInputCountryFlag-aspectRatio));\n    height: var(--PhoneInputCountryFlag-height);\n    max-width: 30px;\n    border-radius: 2px;\n    overflow: hidden;\n  }\n\n  .PhoneInputCountryIcon--square {\n    width: var(--PhoneInputCountryFlag-height);\n  }\n\n  .PhoneInputCountryIcon--border {\n    background-color: var(--PhoneInputCountryFlag-backgroundColor--loading);\n    box-shadow: 0 0 0 var(--PhoneInputCountryFlag-borderWidth) var(--PhoneInputCountryFlag-borderColor),\n      inset 0 0 0 var(--PhoneInputCountryFlag-borderWidth) var(--PhoneInputCountryFlag-borderColor);\n  }\n\n  .PhoneInputCountryIconImg {\n    display: block;\n    width: 100%;\n    height: 100%;\n  }\n\n  .PhoneInputInternationalIconPhone {\n    opacity: var(--PhoneInputInternationalIconPhone-opacity);\n  }\n\n  .PhoneInputInternationalIconGlobe {\n    opacity: var(--PhoneInputInternationalIconGlobe-opacity);\n  }\n\n  .PhoneInputCountry {\n    position: relative;\n    align-self: stretch;\n    display: flex;\n    align-items: center;\n    margin-right: var(--PhoneInputCountrySelect-marginRight);\n  }\n\n  .PhoneInputCountrySelect {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n    z-index: 1;\n    border: 0;\n    opacity: 0;\n    cursor: pointer;\n  }\n\n  .PhoneInputCountrySelect[disabled] {\n    cursor: default;\n  }\n\n  .PhoneInputCountrySelectArrow {\n    display: block;\n    content: '';\n    width: var(--PhoneInputCountrySelectArrow-width);\n    height: var(--PhoneInputCountrySelectArrow-width);\n    margin-left: var(--PhoneInputCountrySelectArrow-marginLeft);\n    border-style: solid;\n    border-color: var(--PhoneInputCountrySelectArrow-color);\n    border-top-width: 0;\n    border-bottom-width: var(--PhoneInputCountrySelectArrow-borderWidth);\n    border-left-width: 0;\n    border-right-width: var(--PhoneInputCountrySelectArrow-borderWidth);\n    transform: var(--PhoneInputCountrySelectArrow-transform);\n    opacity: var(--PhoneInputCountrySelectArrow-opacity);\n  }\n\n  .PhoneInputCountrySelect:focus + .PhoneInputCountryIcon + .PhoneInputCountrySelectArrow {\n    opacity: 1;\n    color: var(--PhoneInputCountrySelectArrow-color--focus);\n  }\n\n  .PhoneInputCountrySelect:focus + .PhoneInputCountryIcon--border {\n    box-shadow: 0 0 0 var(--PhoneInputCountryFlag-borderWidth) var(--PhoneInputCountryFlag-borderColor--focus),\n      inset 0 0 0 var(--PhoneInputCountryFlag-borderWidth) var(--PhoneInputCountryFlag-borderColor--focus);\n  }\n\n  .PhoneInputCountrySelect:focus + .PhoneInputCountryIcon .PhoneInputInternationalIconGlobe {\n    opacity: 1;\n    color: var(--PhoneInputCountrySelectArrow-color--focus);\n  }\n}\n\n.container {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.fieldError {\n  position: absolute;\n  right: 0px;\n}\n\n.error {\n  border-color: var(--colors-red);\n  box-shadow: 0 0 3px var(--colors-red);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `app-components-Form-PhoneInput-___PhoneInput-module__container`,
	"fieldError": `app-components-Form-PhoneInput-___PhoneInput-module__fieldError`,
	"error": `app-components-Form-PhoneInput-___PhoneInput-module__error`
};
export default ___CSS_LOADER_EXPORT___;
